module.exports = __webpack_public_path__ + "img/es.7afd79c8.svg";